import React, { useState, useEffect } from "react";
import BaseEmailComponent from "../BaseEmailComponent";
import EmailImageUpload from "../EmailImageUpload";
import { Form, Row, Col } from "react-bootstrap";

const HeaderImageText = ({ id, data, onUpdate, styleSettings }) => {
  const [image, setImage] = useState(data?.image || null);
  const [price, setPrice] = useState(data?.price || "0.00");
  const [instock, setInstock] = useState(data?.instock || "In Stock");

  // Update state when data changes
  useEffect(() => {
    if (data) {
      setImage(data.image || null);
      setPrice(data.price || "0.00");
      setInstock(data.instock || "In Stock");
    }
  }, [data]);

  // Handle image update
  const handleImageUpload = (imageData) => {
    setImage(imageData);
    
    if (onUpdate) {
      onUpdate({
        ...data,
        image: imageData
      }, id);
    }
  };

  // Edit UI with forms and image upload
  const renderEditUI = (props) => {
    const { title, setTitle, description, setDescription, handleSaveChanges } = props;
    
    // Function to save all changes at once
    const saveAllChanges = () => {
      handleSaveChanges(title, description, { 
        image, 
        price, 
        instock,
        // Allow for secondary description
        description2: data?.description2 || ""
      });
    };

    return (
      <div className="p-3 rounded" style={{ backgroundColor: 'white' }}>
        <Row>
          <Col md={4}>
            <EmailImageUpload
              imageUrl={image}
              onImageUpdate={handleImageUpload}
              className="header-image-upload"
            />
          </Col>
          <Col md={8}>
            <Form.Group className="mb-3">
              <Form.Label><strong>Product Title</strong></Form.Label>
              <Form.Control
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                onBlur={saveAllChanges}
              />
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label><strong>Price</strong></Form.Label>
                  <Form.Control
                    type="text"
                    value={price}
                    onChange={(e) => {
                      setPrice(e.target.value);
                      
                      if (onUpdate) {
                        onUpdate({
                          ...data,
                          price: e.target.value
                        }, id);
                      }
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label><strong>Stock Status</strong></Form.Label>
                  <Form.Control
                    type="text"
                    value={instock}
                    onChange={(e) => {
                      setInstock(e.target.value);
                      
                      if (onUpdate) {
                        onUpdate({
                          ...data,
                          instock: e.target.value
                        }, id);
                      }
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label><strong>Description</strong></Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                onBlur={saveAllChanges}
              />
            </Form.Group>
          </Col>
        </Row>
      </div>
    );
  };

  // View UI for display mode
  const renderViewUI = (props) => {
    const { title, description } = props;
    const { primaryColor, secondaryColor, fontFamily } = styleSettings || {};

    return (
      <Row className="align-items-center">
        <Col md={4}>
          <div className="rounded p-2 d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
            {image ? (
              <img src={image} alt="Product" className="img-fluid rounded" />
            ) : (
              <div className="d-flex align-items-center justify-content-center h-100 outline-none rounded">
                <img
                  src="/img-preview.svg"
                  alt="img-preview"
                  className="img-fluid rounded"
                />
              </div>
            )}
          </div>
        </Col>
        <Col md={8}>
          <h2 style={{ 
            fontSize: "24px", 
            marginBottom: "10px",
            color: secondaryColor || "#a1894c",
            fontFamily,
            fontWeight: "bold"
          }}>
            {title}
          </h2>
          <div className="d-flex align-items-center mt-2 gap-3 mb-3">
            <span style={{ 
              fontSize: "18px", 
              fontWeight: "bold",
              color: primaryColor || "#333333",
              fontFamily
            }}>
              ${price}
            </span>
            <span style={{ 
              fontSize: "14px",
              color: "#28a745",
              fontFamily
            }}>
              {instock}
            </span>
          </div>
          <p className="description-text" style={{ 
            fontFamily,
            color: "#666666"
          }}>
            {description}
          </p>
        </Col>
      </Row>
    );
  };

  return (
    <BaseEmailComponent
      id={id}
      data={{...data, price, instock}}
      onUpdate={onUpdate}
      componentName="Product Header"
      styleSettings={styleSettings}
      editUI={renderEditUI}
      viewUI={renderViewUI}
      previewMode={data?.previewMode}
    />
  );
};

export default HeaderImageText; 